import { DataBean } from "../DataBean";

export class CostSettlement extends DataBean {
    public async updateCostSettlement(bean: any): Promise<any> {
        return this.getCustomService(
            "ProcessContractERP",
            "com.orange.finance.processcontract.bean.CostSettlement_updateCostSettlement_com.orange.finance.processcontract.bean.CostSettlement",
            [
                {
                    "DataBeanProperties": bean,
                    "DataBeanName": "com.orange.finance.processcontract.bean.CostSettlement"
                }
            ]
        );
    }

}